export default {
      id: "login-mk-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-mk-usage",
      toString: function () {
        return this.url;
      }
    }